import { useEffect, useRef, useState } from 'react';
import * as bip39 from 'bip39';
import { useGlobalStateSelector, words } from './globalState';
import { TextArea2 } from './UtilComponents';
import { handleClickLogin } from './login';
import { handleClickSwapMnemonics } from './walletCore';
import {
  handleClickAuthenticate,
  UnregisterAddress,
  UnregisterCredential,
  SavePasswordEncryptedSecrets,
  LoadPasswordEncryptedSecrets,
} from './KeyBox';
import {
  handleClickGoTop,
  handleClickScanQr,
  writeNdefRecordsOnNfc,
  readNfc,
  decodeNdefRecord,
} from './utils';
import {
  encryptNfcRecords,
  decryptNfcRecords,
  prepareNfcrwHandshake,
  prepareNfcrwScan,
  getNfcEncryptedWriteUniversalLink,
  writeNfcrwCallbackToLocalStorage,
  readAndClearNfcrwCallbackFromLocalStorage,
  clearNfcrwCallbackFromLocalStorage,
} from './nativeApp';
import {
  getAddressFromKey,
  getKeyPairsFromMnemonic,
  handleClickNfc,
  keepKeyPairsInMemory,
  walletsAvailable,
  encryptByKeyCardStyle,
  decryptByKeyCardStyle,
  formatToKeyCardStyle,
  formatToSingleTextRecord,
  generateMnemonic,
} from './keysAndSigning';
import iconKeyBox from './image/box_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconKeyCard from './image/playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './image/qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconEdit from './image/edit_FILL0_wght400_GRAD0_opsz48.svg';

// SWAP MNEMONICS
function SwapMnemonics() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    return null;
  }

  if (!('NDEFReader' in window)) {
    return null;
  }


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.swapMnemonics[state.language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearAddress(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          handleClickSwapMnemonics(state, dispatch);
        }}
      >
        <div>
          { words.display[state.language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          localStorage.removeItem('swapStatus');
          localStorage.removeItem('oldAddress');
          localStorage.removeItem('oldKeyPair');
          localStorage.removeItem('oldMnemonic');
          localStorage.removeItem('newAddress');
          localStorage.removeItem('newMnemonic');
          localStorage.removeItem('sweepAssetsTxid');
          localStorage.removeItem('sendMonaTxid');
          dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: '' }); // 暫定
        }}
      >
        <div>
          { words.display[state.language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.swapMnemonics }
      </div>
    </div>
  );
}

// SETTING
function Setting() {
  const language = useGlobalStateSelector(({ state }) => state.language || 'english');
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <div className='flexRow ' >
            <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
              { words.back[language] }
            </button>
          </div>
        </div>
        {/* <UserRegistration mode='all' /> */}
        <SwitchDisplayName />
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        <SwapMnemonics />
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
            { words.back[language] }
          </button>
        </div>
        {/* <UserRegistration mode='all' /> */}
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        <SwapMnemonics />
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
      </div>
    </div>
  );
}

// SWITCH DISPLAY NAME
function SwitchDisplayName() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div>
        { words.switchDisplayNamesInTheCardList[state.language] }
      </div>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'cardName' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'cardName'});
          }}
        >
          <div>
            {words.monacardName[state.language]}
          </div>
        </button>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'asset_longname' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'asset_longname'});
          }}
        >
          <div>
            {words.asset_longname[state.language]}
          </div>
        </button>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'asset' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'asset'});
          }}
        >
          <div>
            {words.asset[state.language]}
          </div>
        </button>
      </div>
    </div>
  );
}

// DISPLAY MNEMONIC
function DisplayMnemonic(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const mnemonic = useGlobalStateSelector( ({ state }) => state.displaySecret.mnemonic );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const login = useGlobalStateSelector( ({ state }) => state.login );
  const walletType = useGlobalStateSelector( ({ state }) => state.walletType );
  const session = useGlobalStateSelector( ({ state }) => state.session );
  const marginOfSessionTime = useGlobalStateSelector( ({ state }) => state.marginOfSessionTime );
  const assetInfos = useGlobalStateSelector( ({ state }) => state.assetInfo );
  const monacards = useGlobalStateSelector( ({ state }) => state.monacard );
  const hasCamera = useGlobalStateSelector( ({ state }) => state.device?.hasCamera );
  const pass = useGlobalStateSelector( ({ state }) => state.config.clientParameters.specialMessage );
  const network = useGlobalStateSelector( ({ state }) => state.networkMona );
  const clientParameters = useGlobalStateSelector( ({ state }) => state.config.clientParameters );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const expectedNfcrwStateRef = useRef(null);
  const nfcrwSessionRef = useRef(null); // ブラウザ側のセッション鍵ペア
  const [nfcrwHandshakeLink, setNfcrwHandshakeLink] = useState(null); // 鍵交換用 Universal Link
  const [nfcrwWriteLink, setNfcrwWriteLink] = useState(null); // 暗号化済み書き込みリンク（鍵交換完了後にセットされる）
  // 鍵交換セッションはプレーンテキストとキーカードで共有する。
  // 最後に完了した鍵交換が書き込みフォーマットを決める（先にプレーン、後にキーカードならキーカード形式。逆も同じ）。
  // 2回目の鍵交換が終わるまでは1回目の書き込みボタンが残る。そこで書くと1回目のフォーマットのままタグへ書かれる。
  const nfcrwWriteFormatRef = useRef(null); // 書き込み意図: 'plain' | 'keycard'
  const expectedNfcrwScanStateRef = useRef(null);
  const nfcrwScanSessionRef = useRef(null); // 読み込み用のブラウザ側セッション鍵ペア
  const [nfcrwScanLink, setNfcrwScanLink] = useState(null); // 暗号化スキャン用 Universal Link
  const nfcrwScanFormatRef = useRef(null); // 読み込み意図: 'plain' | 'keycard'

  // タップ時に同期的に href を確定できるよう、ハンドシェイク用 Universal Link を事前に組み立てておく
  useEffect( () => {
    if (!nfcrwSessionRef.current) {
      prepareNfcrwHandshake({ language }).then( ({ session, state, handshakeLink }) => {
        nfcrwSessionRef.current = session;
        expectedNfcrwStateRef.current = state;
        setNfcrwHandshakeLink(handshakeLink);
      });
    }
  }, [language]);

  // タップ時に同期的に href を確定できるよう、暗号化スキャン用 Universal Link も事前に組み立てておく
  useEffect( () => {
    if (!nfcrwScanSessionRef.current) {
      prepareNfcrwScan({ language }).then( ({ session, state, scanLink }) => {
        nfcrwScanSessionRef.current = session;
        expectedNfcrwScanStateRef.current = state;
        setNfcrwScanLink(scanLink);
      });
    }
  }, [language]);

  // ネイティブアプリからの結果（鍵交換応答・書き込み結果・スキャン結果）は、起き上がった元タブが localStorage から自分で読む
  useEffect( () => {
    // 暗号化スキャンの結果: 復号してニーモニックとして表示し、次回用のセッションを作り直す
    const consumeScanCallback = async () => {
      const expectedState = expectedNfcrwScanStateRef.current;

      if (!expectedState) {
        return;
      }

      const payload = readAndClearNfcrwCallbackFromLocalStorage({ state: expectedState });

      if (!payload) {
        return;
      }

      const session = nfcrwScanSessionRef.current;

      // セッションは使い捨てとし、すぐに次回用を作り直す
      expectedNfcrwScanStateRef.current = null;
      nfcrwScanSessionRef.current = null;
      setNfcrwScanLink(null);

      prepareNfcrwScan({ language }).then( ({ session, state, scanLink }) => {
        nfcrwScanSessionRef.current = session;
        expectedNfcrwScanStateRef.current = state;
        setNfcrwScanLink(scanLink);
      });

      if (payload.error || !payload.pubkey || !payload.ciphertext || !session) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
        return;
      }

      let records;

      try {
        ({ records } = await decryptNfcRecords({
          keyPair: session.keyPair,
          browserPublicKey: session.browserPublicKey,
          appPublicKeyB64: payload.pubkey,
          ciphertextB64: payload.ciphertext,
          state: expectedState,
        }));
      }
      catch {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
        return;
      }

      const scanFormat = nfcrwScanFormatRef.current;
      nfcrwScanFormatRef.current = null;

      if (scanFormat === 'keycard') {
        const recordNo = 1;
        const record = records?.[recordNo];

        if (record?.kind !== 'text') {
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
          return;
        }

        const mnemonicFromKeyCard = await decryptByKeyCardStyle({ pass, dispatch, encrypted: record.value, language });
        handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonicFromKeyCard] });
        dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        return;
      }

      const recordNo = 0;
      const record = records?.[recordNo];

      if (record?.kind !== 'text') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
        return;
      }

      handleClickDisplayMnemonic({ dispatch, mnemonics: [record.value] });
      dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
    };

    // 書き込み側（鍵交換応答・書き込み結果）
    const consumeWriteCallback = async () => {
      const expectedState = expectedNfcrwStateRef.current;

      if (!expectedState) {
        return;
      }

      const payload = readAndClearNfcrwCallbackFromLocalStorage({ state: expectedState });

      if (!payload) {
        return;
      }

      // 鍵交換の応答: アプリ公開鍵から AES 鍵を導出してニーモニックを暗号化し、書き込みフェーズへ進む
      // セッションは共有のため、最後に完了した鍵交換の nfcrwWriteFormatRef でレコードを作り直し、nfcrwWriteLink を置き換える。
      if (payload.pubkey) {
        const session = nfcrwSessionRef.current;

        if (!session) {
          return;
        }

        let records;

        if (nfcrwWriteFormatRef.current === 'keycard') {
          const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });
          records = [
            { kind: 'uri', value: 'https://knightsofmonadom.monatoka.com/?wallettype=nfc' },
            { kind: 'text', value: encryptedMnemonic },
          ];
        }
        else {
          records = [ { kind: 'text', value: mnemonic } ];
        }

        const ciphertextB64 = await encryptNfcRecords({
          keyPair: session.keyPair,
          browserPublicKey: session.browserPublicKey,
          appPublicKeyB64: payload.pubkey,
          records,
          state: expectedState,
        });

        setNfcrwWriteLink(getNfcEncryptedWriteUniversalLink({ ciphertextB64, state: expectedState, language }));
        dispatch({ type: 'setNotification', key: 'notification', value: words.readyToWriteEncryptedData[language] });

        // expectedState は書き込み完了通知まで維持する
        return;
      }

      // 書き込み結果: セッションを終了し、次回用の鍵ペアを作り直す
      expectedNfcrwStateRef.current = null;
      nfcrwSessionRef.current = null;
      nfcrwWriteFormatRef.current = null;
      setNfcrwWriteLink(null);
      setNfcrwHandshakeLink(null);

      prepareNfcrwHandshake({ language }).then( ({ session, state, handshakeLink }) => {
        nfcrwSessionRef.current = session;
        expectedNfcrwStateRef.current = state;
        setNfcrwHandshakeLink(handshakeLink);
      });

      if (payload.nfc) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.wroteOnNfc[language] });
      }
      else if (payload.error === 'session_expired') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.nfcSessionExpired[language] });
      }
      else if (payload.error === 'verify_failed') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.nfcVerifyFailed[language] });
      }
      else if (payload.error) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToWriteOnNfc[language] });
      }
    };

    // state の照合で読み込み・書き込みのどちらの結果かを振り分ける
    const consumeCallback = async () => {
      await consumeScanCallback();
      await consumeWriteCallback();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        consumeCallback();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', consumeCallback);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', consumeCallback);
    };
  }, [dispatch, language, mnemonic, pass]);

  // 画面を離れると鍵ペアと expected state も消えるため、消費できなくなったコールバックを捨てる
  // 同じオリジンで設定タブが複数あると、一方のアンマウントが他方の待ち結果も消す。ただしキーが一つなので、現状でも上書きで壊れやすい。
  useEffect( () => {
    return () => {
      clearNfcrwCallbackFromLocalStorage();
    };
  }, []);

  let readButtons = [];
  let writeButtons = [];

  const keyboxButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyboxMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          try {
            dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });
            const {
              decryptedMnemonicRecords: mnemonicRecords,
              decryptedWifRecords: wifRecords,
              keyPairs,
            } = await handleClickAuthenticate({ dispatch, network, language });

            const secretRecordsByAddress = new Map(
              [ ...mnemonicRecords, ...wifRecords ].map( (secretRecord) => [ secretRecord.address, secretRecord ] )
            );
            const keyPairsToLogin = Array.from(secretRecordsByAddress.values())
            .filter( ( secretRecord ) => user[secretRecord.address]?.basicInformation === undefined )
            .map( ( secretRecord ) => secretRecord.keyPair );

            if (keyPairsToLogin.length >= 1) {
              handleClickLogin({
                dispatch,
                popupLayer: popupLayerNext + 1, // selectSecretPopup の上に描画する。
                keyPairs: keyPairsToLogin,
                sessionToOverride: {},
                login,
                walletType,
                session,
                marginOfSessionTime,
                assetInfos,
                monacards,
                network,
                clientParameters,
                language,
              })
              .catch( () => {
                // 握りつぶす
              });
            }

            if (mnemonicRecords.length === 0) {
              dispatch({ type: 'setNotification', key: 'notification', value: words.noMnemonicRecordsFound[language] });
              throw new Error('No mnemonic records found');
            }

            const { mnemonic } = await new Promise( (resolve, reject) => {
              const popup = {
                type: 'selectSecretPopup',
                body: {
                  secretRecords: mnemonicRecords,
                  resolve,
                  reject,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            });

            handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
            dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
            keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
          finally {
            dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
          }
        }}
      >
        <div>
        { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyBox} alt='' />
        </div>
      </button>
    </>;

  const nfcButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardNfcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 1;
          const record = records?.[recordNo];

          const encryptedMnemonic = decodeNdefRecord({ dispatch, record, language });
          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  const nfcPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readNfcPlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 0;
          const record = records?.[recordNo];

          const text = decodeNdefRecord({ dispatch, record, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [text] });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // ネイティブアプリで NFC を読み込む（アプリが読み取り結果を暗号化して返し、ブラウザでキーカード形式として復号する）
  const readKeyCardNfcWithNativeAppButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardNfcMnemonicWithNativeApp[language] }
      </div>
      <a className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        href={ nfcrwScanLink }
        onClick={ (event) => {
          if (!nfcrwScanLink) {
            event.preventDefault();
            return;
          }

          nfcrwScanFormatRef.current = 'keycard';
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </a>
    </>;

  // ネイティブアプリで NFC を読み込む（アプリが読み取り結果を暗号化して返し、ブラウザで復号する）
  const readNfcPlainTextWithNativeAppButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readNfcPlainTextMnemonicWithNativeApp[language] }
      </div>
      <a className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        href={ nfcrwScanLink }
        onClick={ (event) => {
          if (!nfcrwScanLink) {
            event.preventDefault();
            return;
          }

          nfcrwScanFormatRef.current = 'plain';
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </a>
    </>;

  const qrButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardBcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const encryptedMnemonic = await new Promise( (resolve, reject) => {
            const popup = {
              type: 'qrCodeReaderPopup',
              body: {
                resolve,
                reject,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          });

          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const qrPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.read2dBarcodePlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const data = await new Promise( (resolve, reject) => {
            const popup = {
              type: 'qrCodeReaderPopup',
              body: {
                resolve,
                reject,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          });

          handleClickDisplayMnemonic({ dispatch, mnemonics: [data] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const mnemonicInputButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.inputMnemonicAction[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'mnemonicInputPopup',
            body: {
              stateKeys: ['displaySecret', 'mnemonic']
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.input[language] }
        </div>
        <div>
          <img className='size2x2' src={iconEdit} alt='' />
        </div>
      </button>
    </>;

  const generateMnemonicButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.generateMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const { mnemonic } = generateMnemonic({ dispatch, network, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
        }}
      >
        <div>
          { words.generate[language] }
        </div>
      </button>
    </>;

  const writeInKeycardNfcFormatButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInKeyCardNfcFormat[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });

          const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });
          const records = formatToKeyCardStyle({ data: encryptedMnemonic });
          writeNdefRecordsOnNfc({ dispatch, records, language });
        }}
      >
        <div>
          { words.write[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  const writeInPlainTextToNfcButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInPlainTextToNfc[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });

          const records = formatToSingleTextRecord({ data: mnemonic });
          writeNdefRecordsOnNfc({ dispatch, records, language });
        }}
      >
        <div>
          { words.write[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // フェーズ1: 鍵交換（アプリは NFC に触れず、公開鍵だけ返してくる）
  const exchangeKeysForKeycardWithNativeAppButton =
    <a className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
      href={ nfcrwHandshakeLink }
      onClick={ (event) => {
        if (!nfcrwHandshakeLink) {
          event.preventDefault();
          return;
        }

        nfcrwWriteFormatRef.current = 'keycard';
        dispatch({ type: 'setNotification', key: 'notification', value: words.exchangingEncryptionKeysWithTheApp[language] });
      }}
    >
      <div>
        { words.write1of2[language] }
      </div>
      <div>
        <img className='size2x2' src={iconKeyCard} alt='' />
      </div>
    </a>;

  const exchangeKeysForPlainWithNativeAppButton =
    <a className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
      href={ nfcrwHandshakeLink }
      onClick={ (event) => {
        if (!nfcrwHandshakeLink) {
          event.preventDefault();
          return;
        }

        nfcrwWriteFormatRef.current = 'plain';
        dispatch({ type: 'setNotification', key: 'notification', value: words.exchangingEncryptionKeysWithTheApp[language] });
      }}
    >
      <div>
        { words.write1of2[language] }
      </div>
      <div>
        <img className='size2x2' src={iconKeyCard} alt='' />
      </div>
    </a>;

  // フェーズ2: 暗号化済みデータを渡して書き込み
  const writeEncryptedToNfcWithNativeAppButton =
    <a className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
      href={ nfcrwWriteLink }
      onClick={ () => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
      }}
    >
      <div>
        { words.write2of2[language] }
      </div>
      <div>
        <img className='size2x2' src={iconKeyCard} alt='' />
      </div>
    </a>;

  let keycardNativeAppWriteActionButton;

  if (nfcrwWriteLink !== null && nfcrwWriteFormatRef.current === 'keycard') {
    keycardNativeAppWriteActionButton = writeEncryptedToNfcWithNativeAppButton;
  }
  else {
    keycardNativeAppWriteActionButton = exchangeKeysForKeycardWithNativeAppButton;
  }

  let plainNativeAppWriteActionButton;

  if (nfcrwWriteLink !== null && nfcrwWriteFormatRef.current === 'plain') {
    plainNativeAppWriteActionButton = writeEncryptedToNfcWithNativeAppButton;
  }
  else {
    plainNativeAppWriteActionButton = exchangeKeysForPlainWithNativeAppButton;
  }

  const writeInKeyCardNfcFormatWithNativeAppButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInKeyCardNfcFormatWithNativeApp[language] }
      </div>
      { keycardNativeAppWriteActionButton }
    </>;

  const writeInPlainTextToNfcWithNativeAppButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInPlainTextToNfcWithNativeApp[language] }
      </div>
      { plainNativeAppWriteActionButton }
    </>;

  const displayQrInKeycardBcFormatButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.display2dBarcodeInKeyCardBcFormat[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });

          const popup = {
            type: 'displayQrPopup',
            body: {
                data: encryptedMnemonic,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const displayQrInPlainTextButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.display2dBarcodeInPlainText[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
                data: mnemonic,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  for (const wallet of walletsAvailable({ hasCamera })) {
    if (wallet === 'keybox') {
      readButtons.push(keyboxButton);
    }
    else if (wallet === 'nfc') {
      readButtons.push(nfcButton, nfcPlainButton);
      writeButtons.push(writeInKeycardNfcFormatButton, writeInPlainTextToNfcButton);
    }
    else if (wallet === 'nfcNative') {
      readButtons.push(readKeyCardNfcWithNativeAppButton, readNfcPlainTextWithNativeAppButton);
      writeButtons.push(writeInKeyCardNfcFormatWithNativeAppButton, writeInPlainTextToNfcWithNativeAppButton);
    }
    else if (wallet === 'qr') {
      readButtons.push(qrButton, qrPlainButton);
      writeButtons.push(displayQrInKeycardBcFormatButton, displayQrInPlainTextButton);
    }
  }

  readButtons.push(mnemonicInputButton, generateMnemonicButton);

  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.readDisplayAndWriteMnemonic[language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearMnemonic({ dispatch }) }
        >
          {words.clear[language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      { readButtons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
        { mnemonic }
      </div>
      { writeButtons }
    </div>
  );
}

// DISPLAY WIF
function DisplayWif() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  let buttons;

  const nfcButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (mnemonics, keyPairs) => handleClickDisplayWif(state, dispatch, mnemonics, keyPairs);
      handleClickNfc(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconKeyCard} alt='' />
    </div>
  </button>;

  const qrButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (mnemonics, keyPairs) => handleClickDisplayWif(state, dispatch, mnemonics, keyPairs);
      handleClickScanQr(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconQr} alt='' />
    </div>
  </button>;

  if ('NDEFReader' in window && state.device.hasCamera) {
    buttons =
    <div className=''>
      { nfcButton }
      { qrButton }
    </div>;
  }
  else if ('NDEFReader' in window) {
    buttons =
    <div className=''>
      { nfcButton }
    </div>;
  }
  else if (state.device.hasCamera) {
    buttons =
    <div className=''>
      { qrButton }
    </div>;
  }
  else {
    return null;
  }


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.displayWif[state.language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearWif(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
      </div>
      { buttons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.wif }
      </div>
    </div>
  );
}

// DISPLAY ADDRESS
function DisplayAddress() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  let buttons;

  const nfcButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (mnemonics, keyPairs) => handleClickDisplayAddress(state, dispatch, mnemonics, keyPairs);
      handleClickNfc(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconKeyCard} alt='' />
    </div>
  </button>;

  const qrButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (mnemonics, keyPairs) => handleClickDisplayAddress(state, dispatch, mnemonics, keyPairs);
      handleClickScanQr(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconQr} alt='' />
    </div>
  </button>;

  if ('NDEFReader' in window && state.device.hasCamera) {
    buttons =
    <div className=''>
      { nfcButton }
      { qrButton }
    </div>;
  }
  else if ('NDEFReader' in window) {
    buttons =
    <div className=''>
      { nfcButton }
    </div>;
  }
  else if (state.device.hasCamera) {
    buttons =
    <div className=''>
      { qrButton }
    </div>;
  }
  else {
    return null;
  }


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.displayAddress[state.language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearAddress(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      { buttons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.address }
      </div>
    </div>
  );
}

// GET THE PRIVATE KEY FROM THE MNEMONIC
function GetThePrivateKeyFromTheMnemonic() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div className='flexColumn alignItemsFlexStart '>
          <div>
            { words.getThePrivateKeyFromTheMnemonic[state.language] }
          </div>
          <div>
            { words.restoringToAnotherWalletFromABackup[state.language] }
          </div>
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearMnemonicAndWif(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
      </div>
      <TextArea2 fieldName='settingWifFromMnemonic' keys={['displaySecret', 'mnemonicToWif']} face={words.mnemonic[state.language]}
        outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
      />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          handleClickDisplayWifFromMnemonicFilledIn(state, dispatch);
        }}
      >
        <div>
          { words.display[state.language] }
        </div>
      </button>
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.wifFromMnemonic }
      </div>
    </div>
  );
}

// // WRITE MNEMONIC ON NFC
// function WriteMnemonicOnNfc(props) {
//   const popupLayer = props.popupLayer;
//   const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
//   const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
//   const mnemonic = useGlobalStateSelector( ({ state }) => state.displaySecret.mnemonic );
//   const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
// 
//   let buttons;
// 
//   const keyboxButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ async () => {
//         try {
//           dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });
//           const { decryptedMnemonicRecords: mnemonicRecords, keyPairs } = await handleClickAuthenticate(state, dispatch);
// 
//           const { mnemonic } = await new Promise( (resolve, reject) => {
//             const popup = {
//               type: 'selectMnemonicPopup',
//               body: {
//                 mnemonicRecords,
//                 resolve,
//                 reject,
//               },
//             };
// 
//             dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
//           });
// 
//           handleClickDisplayMnemonic(state, dispatch, [mnemonic]);
//           keepKeyPairsInMemory(state, dispatch, keyPairs);
//         }
//         finally {
//           dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
//         }
//       }}
//     >
//       <div>
//       { words.display[language] }
//       </div>
//       <div>
//         <img className='size2x2' src={iconKeyCard} alt='' />
//       </div>
//     </button>;
// 
//   const nfcButton =
//   <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//     onClick={ async () => {
//       const callback = (mnemonics) => handleClickDisplayMnemonic(state, dispatch, mnemonics);
//       handleClickNfc(state, dispatch, callback, { args: ['mnemonics'] });
//     }}
//   >
//     <div>
//       { words.display[language] }
//     </div>
//     <div>
//       <img className='size2x2' src={iconKeyCard} alt='' />
//     </div>
//   </button>;
// 
//   const qrButton =
//   <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//     onClick={ async () => {
//       const callback = (mnemonics) => handleClickDisplayMnemonic(state, dispatch, mnemonics);
//       handleClickScanQr(state, dispatch, callback, { args: ['mnemonics'] });
//     }}
//   >
//     <div>
//       { words.display[language] }
//     </div>
//     <div>
//       <img className='size2x2' src={iconQr} alt='' />
//     </div>
//   </button>;
// 
//   const writeOnNfcButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ () => {
//         writeOnNfc(null, dispatch, mnemonic, { language });
//       }}
//     >
//       <div>
//         { words.write[language] }
//       </div>
//     </button>
// 
//   const displayQrButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ () => {
//         const popup = {
//           type: 'displayQrPopup',
//           body: {
//               data: mnemonic,
//           },
//         };
// 
//         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
//       }}
//     >
//       <div>
//         { words.display[language] }
//       </div>
//     </button>
// 
//   if ('NDEFReader' in window && state.device.hasCamera) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { nfcButton }
//       { qrButton }
//     </div>;
//   }
//   else if ('NDEFReader' in window) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { nfcButton }
//     </div>;
//   }
//   else if (state.device.hasCamera) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { qrButton }
//     </div>;
//   }
//   else {
//     return null;
//   }
// 
//   return (
//     <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
//       <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
//         <div>
//           { words.displayMnemonic[language] }
//         </div>
//         <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
//           onClick={ () => handleClickClearMnemonic(state, dispatch) }
//         >
//           {words.clear[language]}
//         </button>
//       </div>
//       <div className='widthMax colorRed marginTop1 '>
//         { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
//       </div>
//       { buttons }
//       <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
//         { state.displaySecret.mnemonic }
//       </div>
//     </div>
//   );
// }

// ネイティブアプリからの復帰タブ。結果を localStorage に書いて案内だけ出す
function NfcCallback() {
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );

  useEffect( () => {
    const url = new URL(window.location.href);
    const state = url.searchParams.get('state');
    const nfc = url.searchParams.get('nfc');
    const error = url.searchParams.get('error');
    const pubkey = url.searchParams.get('pubkey');
    const ciphertext = url.searchParams.get('ciphertext');

    if (state && (nfc || error || pubkey)) {
      writeNfcrwCallbackToLocalStorage({ state, nfc, error, pubkey, ciphertext });
    }

    url.search = '';
    window.history.replaceState({}, '', url);
  }, []);

  return (
    <div className='flexColumn alignItemsCenter marginTop1 padding0p5'>
      { words.pleaseReturnToTheOriginalTabAndCloseThisTab[language] }
    </div>
  );
}

// HANDLE CLICK SETTING
function handleClickSetting(state, dispatch, navigate) {
  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/setting' : '/setting');
}


// HANDLE CLICK DISPLAY MNEMONIC
function handleClickDisplayMnemonic({ dispatch, mnemonics }) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: mnemonics[0] });
  // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicHidden'], value: mnemonics[0] });

  return;
}

// HANDLE CLICK CLEAR MNEMONIC
function handleClickClearMnemonic({ dispatch }) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: '' });

  return;
}

// HANDLE CLICK DISPLAY WIF
function handleClickDisplayWif(state, dispatch, mnemonics, keyPairs) {
  // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicHidden'], value: mnemonics[0] });
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wif'], value: keyPairs[0].toWIF() });

  return;
}

// HANDLE CLICK CLEAR WIF
function handleClickClearWif(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wif'], value: '' });

  return;
}

// HANDLE CLICK DISPLAY ADDRESS
function handleClickDisplayAddress(state, dispatch, mnemonics, keyPairs) {
  let address;

  // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicHidden'], value: mnemonics[0] });

  const result = getAddressFromKey(state, dispatch, keyPairs[0], state.networkMona);

  if (result.status === 'fulfilled') {
    address = result.address;
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'address'], value: address }); 
    return result;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    return result;
  }
}

// HANDLE CLICK DISPLAY WIF FROM MNEMONIC FILLED IN
function handleClickDisplayWifFromMnemonicFilledIn(state, dispatch) {
  const mnemonicFilledIn = state.displaySecret.mnemonicToWif;

  if (!bip39.validateMnemonic(mnemonicFilledIn)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.invalidMnemonic[state.language] });
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: '' });

    throw new Error('invalidMnemonic');
  }

  const keyPairs = getKeyPairsFromMnemonic({ dispatch, network: state.networkMona, mnemonic: mnemonicFilledIn, language: state.language });
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: keyPairs[0].toWIF() });

  return;
}

// HANDLE CLICK CLEAR MNEMONIC AND WIF
function handleClickClearMnemonicAndWif(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicToWif'], value: '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: '' });

  return;
}

// HANDLE CLICK CLEAR ADDRESS
function handleClickClearAddress(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'address'], value: '' });

  return;
}

export {
  Setting,
  NfcCallback,
  handleClickSetting,
};
